import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';

class AlertDialog extends Component {

  render() {

    const {
      open,
      title,
      message,
      onOk,
      onCancel,
      okTitle,
      cancelTitle,
      okColor,
      cancelColor,
      fullScreen
    } = this.props;
    if (fullScreen) {
      return (
        <Dialog
          fullScreen
          open={open}
          onClose={onCancel}
        >
          <DialogTitle>{title}</DialogTitle>
          <DialogContent>
            <DialogContentText>{message}</DialogContentText>
          </DialogContent>
          <DialogActions>
            {onCancel && (
              <Button onClick={onCancel} color={cancelColor || "primary"}>
                {cancelTitle || "Cancel"}
              </Button>
            )}
            {onOk && (
              <Button onClick={onOk} color={okColor || "primary"}>
                {okTitle || "OK"}
              </Button>
            )}
          </DialogActions>
        </Dialog>
      );
    } else {
      return (
        <Dialog
          open={open}
          onClose={onCancel}
        >
          <DialogTitle>{title}</DialogTitle>
          <DialogContent>
            <DialogContentText>{message}</DialogContentText>
          </DialogContent>
          <DialogActions>
            {onCancel && (
              <Button onClick={onCancel} color={cancelColor || "primary"}>
                {cancelTitle || "Cancel"}
              </Button>
            )}
            {onOk && (
              <Button onClick={onOk} color={okColor || "primary"}>
                {okTitle || "OK"}
              </Button>
            )}
          </DialogActions>
        </Dialog>
      );
    }
  }
}

AlertDialog.defaultProps = {
  onOk: () => {},
  onCancel: () => {}
};

AlertDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  onOk: PropTypes.func,
  onCancel: PropTypes.func
};

export default AlertDialog;
